export function createDateString(dateString, format = "dd-mm-yyyy") {
  const date = new Date(dateString);

  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  let dateInString = `${day}-${month}-${year}`;

  if (format === "yyyy-mm-dd") {
    dateInString = `${year}-${month}-${day}`;
  }

  return dateInString;
}

export function range(start = 0, end = 10, interval = 1) {
  const intStart = parseInt(start);
  const intEnd = parseInt(end);
  const intInterval = parseInt(interval);

  const rangeArr = [];

  for (let i = intStart; i <= intEnd; i += intInterval) {
    rangeArr.push(i);
  }

  return rangeArr;
}

export function amount(str) {
  return `Rp ${parseInt(str).toLocaleString("en-In")}`;
}

export function fullNameText(text = "") {
  const fullName = text
    .toLowerCase()
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  return fullName;
}

export function getAgeFromDate(dateString) {
  var today = new Date();
  var birthDate = new Date(dateString);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}
